import { SupabaseClient } from '@supabase/supabase-js';
import { ZodiosPlugin } from '@zodios/core';

/**
 * Custom plugin for Zodios to inject API key into request headers
 */
const apiTokenPlugin = (supabase: SupabaseClient): ZodiosPlugin => {
  return {
    request: async (_, config) => {
      const { data } = await supabase.auth.getSession();
      const authToken = data.session?.access_token;
      return {
        ...config,
        headers: {
          ...config.headers,
          ...(authToken && { Authorization: `Bearer ${authToken}` }),
        },
      };
    },
  };
};

export default apiTokenPlugin;
